import { render } from "./Widget.vue?vue&type=template&id=577d22bc&scoped=true"
const script = {}

import "./Widget.vue?vue&type=style&index=0&id=577d22bc&scoped=true&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577d22bc"]])

export default __exports__